import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Divider, IconButton, Menu, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import type { BoOption } from '../../shared/types'

export type OptionAction = 'amend' | 'retire' | 'restore' | 'earlier' | 'later'

// Moving lives on the card as arrows now: one affordance, where the eye already is.
export interface OptionActionsMenuProps {
  option: BoOption
  onAction: (action: OptionAction) => void
}

export default function OptionActionsMenu({
  option,
  onAction,
}: OptionActionsMenuProps) {
  const { formatMessage } = useIntl()
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const retired = option.status === 'retired'

  const choose = (action: OptionAction) => {
    setAnchor(null)
    onAction(action)
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label={formatMessage(
          { id: 'avatarStudio.actions.menuAria' },
          { name: option.displayName },
        )}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem onClick={() => choose('amend')}>
          {formatMessage({ id: 'avatarStudio.actions.amend' })}
        </MenuItem>
        <Divider />
        {retired ? (
          <MenuItem onClick={() => choose('restore')}>
            {formatMessage({ id: 'avatarStudio.actions.restore' })}
          </MenuItem>
        ) : (
          <MenuItem onClick={() => choose('retire')}>
            {formatMessage({ id: 'avatarStudio.actions.retire' })}
          </MenuItem>
        )}
      </Menu>
    </>
  )
}
